import { NgClass } from '@angular/common';
import { Component, inject, input, Input, computed } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import Keycloak from 'keycloak-js';

import AdminProfileComponent from 'projects/admin/src/app/components/admin-profile/admin-profile.component';
import { environment } from 'projects/admin/src/environments/environment';
import { HeaderService } from 'projects/client/src/app/service/header.service';
import { SvgAssetComponent } from 'projects/design-system/components/svg-icon/svg-icon.component';
import { INavLink } from 'shared/components/navigation-bar/nav-link.interface';
import { PrivilegeGuardDirective } from 'shared/components/privilege-guard/privilege-guard.component';

export enum MenuModeEnum {
	NORMAL = 'Normal',
	EXTENDED = 'Extended',
}

@Component({
	selector: 'app-admin-side-menu',
	templateUrl: './admin-side-menu.component.html',
	imports: [
		MatButtonModule,
		MatIconModule,
		RouterLink,
		SvgAssetComponent,
		NgClass,
		MatBadgeModule,
		TranslateModule,
		RouterLinkActive,
		AdminProfileComponent,
		PrivilegeGuardDirective,
	],
	standalone: true,
})
export default class AdminSideMenuComponent {
	@Input({ required: false }) navLinks: INavLink[] | null = [];
	menuMode = input<MenuModeEnum>(MenuModeEnum.NORMAL);

	protected roundedMenuItemClass = computed(() =>
		this.headerService.menuOpened() ? ' rounded-l-xl' : ' rounded-xl'
	);
	protected headerService = inject(HeaderService);
	private readonly keycloakService = inject(Keycloak);

	toggleSideMenu() {
		this.headerService.menuOpened.set(!this.headerService.menuOpened());
	}

	logout() {
		this.keycloakService.logout({ redirectUri: environment.keycloakRedirectUrl });
	}
}
